import {
  isAvailableLanguage,
  FI,
  normalizeSupportedLang,
} from 'common/src/vtj/browser/localization'
import { isInsideBrowser } from 'common/src/vtj/browser/browser-util'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
type SupportedUiLanguageCode =
  | LanguageCode.FI
  | LanguageCode.SV
  | LanguageCode.EN
  | LanguageCode.AF

export const parseLanguageFromUrl = (
  url = '',
  defaultLang: SupportedUiLanguageCode = FI
): SupportedUiLanguageCode => {
  const lang = url
    .split('/')
    .find(
      isAvailableLanguage as (
        language: string
      ) => language is SupportedUiLanguageCode
    )
  return lang || defaultLang
}

export const parseLanguageFromLocation = (
  location = '/',
  defaultLang: SupportedUiLanguageCode = FI
): SupportedUiLanguageCode => {
  const url = isInsideBrowser() ? window.location.pathname : location
  return parseLanguageFromUrl(url, defaultLang)
}

export const parseSupportedLanguageFromLocation =
  (supportedLanguages: SupportedUiLanguageCode[]) =>
  (location = '/'): LanguageCode => {
    const url = isInsideBrowser() ? window.location.pathname : location
    return parseSupportedLanguageFromUrl(supportedLanguages, url)
  }

const parseSupportedLanguageFromUrl = (
  supportedLanguages: SupportedUiLanguageCode[],
  url: string
): SupportedUiLanguageCode => {
  const lang = url
    .split('/')
    .find(
      isAvailableLanguage as (
        language: string
      ) => language is SupportedUiLanguageCode
    )
  return normalizeSupportedLang(supportedLanguages, lang)
}
